// extracted by mini-css-extract-plugin
var _1 = "EpostStatusTimelineTracking-modulestatusList__LYnrf EpostStatusTimelineContentContainer-modulecontent__sg1xh";
export { _1 as "statusList" }
